import { Field, FieldArray } from 'formik';

import { InputAtom } from '@/atoms/input/Input';
import { LabelAtom } from '@/atoms/label/Label';

import type { FieldArrayRenderProps, FieldProps } from 'formik';
import type { FunctionComponent } from 'react';
import type { CheckBoxProps } from '../types';

/**
 * Primary UI component for user interaction
 */
export const CustomCheckbox: FunctionComponent<CheckBoxProps> = ({
  className = '',
  name,
  error,
  values,
  multiple = false,
  testid = '',
  onChange,
}: CheckBoxProps) => {
  const handleChange = async (
    // TODO: Añadir tipos
    field: any,
    item: any,
    arrayHelpers: any,
    index: number,
  ) => {
    // Cuando el checkbox es multiple, el index es el index del array
    // Cuando el checkbox no es multiple, el index es 0 porque solo puede haber un valor seleccionado
    if (!multiple) index = 0;

    const found =
      field.value && field.value[index] && field.value[index] == item.value;

    if (found) {
      arrayHelpers.remove(
        // TODO: Añadir tipos
        field.value.findIndex((el: any) => el.value == item),
      );
    } else {
      if (multiple) {
        arrayHelpers.insert(index, item.value);
      } else {
        await arrayHelpers.remove();
        arrayHelpers.insert(0, item.value);
      }
    }
  };
  return (
    <FieldArray
      name={name}
      render={(arrayHelpers: FieldArrayRenderProps) => (
        <div
          className={`${className} relative grid auto-cols-fr grid-flow-col justify-start gap-x-2`}
        >
          {
            // TODO: Añadir tipos
            values.map((item: any, index) => (
              <Field name={name} key={index}>
                {({ field }: FieldProps) => {
                  const checked =
                    field.value &&
                    field.value.find((val: any) => val === item.value);

                  return (
                    <div className={item.disabled ? 'opacity-50' : ''}>
                      <InputAtom
                        hidden
                        name={name}
                        disabled={item.disabled}
                        type="checkbox"
                        checked={checked}
                        error={error}
                        field={field}
                        handleBlur={field.onBlur}
                        handleChange={field.onChange}
                        testid={testid}
                      />

                      <LabelAtom
                        label={item.label}
                        setValue={() => {
                          if (!item.disabled) {
                            onChange && onChange(item.value, index);
                            handleChange(field, item, arrayHelpers, index);
                          }
                        }}
                        className={`!u-subtitle !u-subtitle--l u-body u-body--xs !pointer-events-auto flex h-[46px] w-full cursor-pointer items-center justify-center border px-4 ${checked ? 'bg-black text-white' : 'bg-white'}`}
                        name={item.name}
                        testid={testid}
                      />
                    </div>
                  );
                }}
              </Field>
            ))
          }
        </div>
      )}
    />
  );
};
